import { FC, memo } from 'react'
import { Alert, FormInstance } from 'antd'
import FormItem from 'antd/es/form/FormItem'
import sclasses from '../SetCourseClassDirectionModal/index.module.css'
import spclasses from '../SetCourseClassDirectionModal/purchase.module.css'
import { ICustomClass } from '../SetCourseClassDirectionModal/SetClassModalBody'
import { RequestCreateLeadPaymentLink } from '@/api/types/crm/crm.types'
import { useWatch } from 'antd/es/form/Form'
import SelectClass from './components/SelectClass/SelectClass'
import CreateLinkSectionTitle from './CreateLinkSectionTitle'
import { getCrmLinkTariffTypeLabel } from './tariffTypes'

type FieldType = Omit<RequestCreateLeadPaymentLink, 'lead_funnel_id'>

export interface ClassFieldsProps {
  form: FormInstance<any>
  classesState: { value?: ICustomClass[]; loading: boolean; retry: () => void }
  filterSort: (optionA: any, optionB: any) => number
}

const ClassFields: FC<ClassFieldsProps> = memo((props) => {
  const { form, classesState } = props

  const classIdWatch = useWatch('class_id', form) as number | null
  const selectedClass = classesState.value?.find(
    (item) => item.id === classIdWatch,
  )
  const tariffTypeLabel = selectedClass
    ? selectedClass.one_pay
      ? getCrmLinkTariffTypeLabel('month')
      : 'Оплата отдельно по каждому направлению'
    : null

  return (
    <>
      <div className={sclasses.inputWithLabel}>
        <CreateLinkSectionTitle title="Класс" />
        <FormItem<FieldType>
          name="class_id"
          rules={[{ required: true, message: 'Выберите класс' }]}
          noStyle
        >
          <SelectClass
            className={spclasses.select}
            classesState={classesState}
          />
        </FormItem>
        {tariffTypeLabel ? (
          <div className={spclasses.tariffTypeHint}>
            Тип тарифа: {tariffTypeLabel}
          </div>
        ) : null}
      </div>
      {selectedClass?.one_pay ? (
        <div className={sclasses.textDescription}>
          Базовая стоимость, мес: {selectedClass.amount} ₽
        </div>
      ) : null}
      {selectedClass && !selectedClass?.one_pay ? (
        <Alert
          message="Оплата за данный класс производится отдельно по каждому направлению"
          type="info"
        />
      ) : null}
    </>
  )
})

export default ClassFields
